<script>
  import { createEventDispatcher } from "svelte";

  import Path from "./path.svelte";

  export let layout;
  export let canBeSubmitted = false;
  export let loading = false;
  export let editable;
  export let currentPath;
  export let texts = undefined;

  const dispatch = createEventDispatcher();
</script>

<div class={ $$props.class} class:buttons={ true }>
  {#if editable}
    <div>
      <div class="absolute -mt-8">
        <Path current={ currentPath } on:message={ ({ detail }) => { dispatch('message', detail) } } />
      </div>
      <slot name="submit">
        <button class="save" disabled={ !canBeSubmitted }>
          {#if loading}
            <span class="loading loading-spinner"></span>
          {/if}
          { texts?.buttons?.submit || layout.submitText || 'Save' }
        </button>
      </slot>
    </div>
  {:else}
    <slot name="submit">
      <button class="save" disabled={ !canBeSubmitted }>
        {#if loading}
          <span class="loading loading-spinner"></span>
        {/if}
        { texts?.buttons?.submit || layout.submitText || 'Save' }
      </button>
    </slot>
  {/if}
  {#if layout.cancel}
    <slot name="cancel">
      <button type="button" class="cancel" disabled={ loading } on:click={ () => { dispatch('cancel') } }>
        { texts?.buttons?.cancel || layout.cancelText || 'Cancel' }
      </button>
    </slot>
  {/if}
</div>